import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";

type RedirectCheckFunction = (searchString: string) => boolean;

export interface RedirectCheck {
  includeSearch: boolean;
  redirectTo: string;
  check: RedirectCheckFunction;
}

export interface CheckRedirectChildren {
    checks: RedirectCheck[];
}

const CheckRedirect = ({ checks }: CheckRedirectChildren) => {
  return ({ children }: React.PropsWithChildren) => {
    const [_, redirect] = useLocation(); 
    const searchString = useSearch();

    useEffect(() => {
      checks.forEach(({ check, redirectTo, includeSearch }) => {
        if (check(searchString)) {
          redirect(`${redirectTo + (includeSearch ? "/?" + searchString : "")}`);
        }
      });
    }, []); 

    return (
      <>
      {children}
      </>
    );
  };

};
export default CheckRedirect;
